package cc.bluepeak.clubmanager.site.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import cc.bluepeak.clubmanager.site.Res
import cc.bluepeak.clubmanager.site.components.layouts.PageLayoutData
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.isExporting
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext

@InitRoute
fun initHelp(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Help", ""))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun Help() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        if (AppGlobals.isExporting) return@LaunchedEffect
        ctx.router.navigateTo(Res.link.supportForm)
    }
}